import React from 'react'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import { getEventDescription } from '../../../../../../helpers/eventDescription'
import * as Badges from '../../../../../../components/badges'
import PropTypes from "prop-types"

const DriverPoolPlacedOnline = (props) => {
  return <tr>
    <td><Badges.Online /></td>
    <td>{getEventDescription(props.item, 'Delivery pool brought online')}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

DriverPoolPlacedOnline.propTypes = {
  item: PropTypes.object
}

export default DriverPoolPlacedOnline


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/driverPoolPlacedOnline/index.js